<div class="row">
  <div class="col-12  p-3">
    <h3 class="text-start fs-4">{{ 'onboardingArtistResume.artistStatementAndResume' | transloco }}</h3>
    <ol class=" ms-3 px-1">
      <li>{{ 'onboardingArtistResume.dontBeShy' | transloco }}</li>
      <li>{{ 'onboardingArtistResume.updateStatement' | transloco }}</li>
    </ol>
    @if (authConfig.IsArtist) {
      <p-panel [header]="'onboardingArtistResume.aboutMe' | transloco" [style]="{ 'margin-top': '15px'}" [toggleable]="true">
        <div class="form-horizontal">
          <div class="form-group">
            <angular-editor #emailEditor name="emailEditor" [config]="editorConfig" [(ngModel)]="formData.AboutMe"
              [placeholder]="'onboardingArtistResume.startWritingAboutYourself' | transloco">
            </angular-editor>
          </div>
        </div>
      </p-panel>
    }
  </div>
  <div class="col-12 p-3">
    <div class=" text-start fw-bold fs-5">{{ 'onboardingArtistResume.yourResume' | transloco }}</div>
    <ol class="ms-3 px-1 mb-2 ">
      <li>{{ 'onboardingArtistResume.letGalleriesKnow' | transloco }}</li>
      <li>{{ 'onboardingArtistResume.suchInformationHelps' | transloco }}</li>
    </ol>
    @if (authConfig.IsArtist) {
      <p-panel [header]="'onboardingArtistResume.yourResumeEditor' | transloco" [style]="{ 'margin-top': '15px'}" [toggleable]="true"
        >
        <div class="form-horizontal">
          <div class="form-group">
            <!-- <label class="form-label" for="resumeEditor">Resume</label> -->
            <angular-editor #resumeEditor name="resumeEditor" [config]="resumeEditorConfig" [(ngModel)]="formData.Resume"
              [placeholder]="'onboardingArtistResume.startWritingAboutEducation' | transloco">
            </angular-editor>
          </div>
        </div>
      </p-panel>
    }
  </div>
  <div class="dsButtonDiv justify-content-between d-flex  mt-3 mb-2">
    <button class="btn btn-outline-secondary"  routerLink="/">{{ 'onboardingArtistResume.skip' | transloco }}</button>
    <button type="button" pButton [label]="'onboardingArtistResume.saveAndNext' | transloco" (click)="updateProfile()" class="btn btn-outline-secondary">
    </button>
  </div>
</div>